import React, {
  FC,
  PropsWithChildren,
  useEffect,
  useRef,
  useState
} from "react";
import styled from "styled-components";

import { visibilityTransition } from "../styles/commonStyles";

const FadingWrapper = styled.div<{ visible: boolean }>`
  ${props => visibilityTransition(props.visible)}
`;

interface Props extends PropsWithChildren {
  isVisible: boolean;
}

/**
 * Renders and removes component with fading effect
 */
export const FadingComponent: FC<Props> = ({ children, isVisible }) => {
  const [shouldRenderElement, setShouldRenderElement] = useState(isVisible);
  const renderTimeout = useRef<number>(undefined);
  const initialRenderDone = useRef(false);

  useEffect(() => {
    if (!initialRenderDone.current) {
      initialRenderDone.current = true;
      return;
    }

    // Always render button on buttonVisible change,
    // the css animation will do the fade effect
    setShouldRenderElement(true);
    renderTimeout.current = window.setTimeout(() => {
      setShouldRenderElement(isVisible);
    }, 200);

    return () => {
      clearTimeout(renderTimeout.current);
      renderTimeout.current = undefined;
    };
  }, [isVisible]);

  return shouldRenderElement ? (
    <FadingWrapper visible={isVisible}>{children}</FadingWrapper>
  ) : null;
};
